import { Routes, LOGIN, LANDING_PAGE } from "routes/RouteConstants";
import { isMobileDevice } from "services/utils";
import CookieService from "services/CookieService";

export const layoutConfig = {
  [Routes.TEAM_JOINING_FORM]: {
    title: "Setting up your team",
    showHeader: true,
    showCredits: false,
    showBack: false,
    containerStyle: {
      useContainer: true
    },
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: false
    }
  },
  [Routes.DASHBOARD]: {
    title: "Jobs",
    showHeader: true,
    containerStyle: {
      useContainer: false
    },
    sidebar: {
      defaultExpanded: true,
      visible: true,
      useV2Layout: true
    },
    backgroundColor: "bg-muted"
  },
  [Routes.OVERVIEW]: {
    title: "Home",
    showHeader: true,
    containerStyle: {
      useContainer: true
    },
    sidebar: {
      defaultExpanded: true,
      visible: true,
      useV2Layout: true
    },
    backgroundColor: "bg-muted",
    showTeamAddUserModal: true
  },
  [Routes.JOB_POSTING_FORM]: {
    title: "Job Posting",
    showHeader: true,
    showBack: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.CANDIDATE_LISTING]: {
    title: "Candidates",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    hideCustomerSupport: true,
    visibleWithBackBtn: true
  },
  [Routes.PROFILE]: {
    title: "Profile",
    showHeader: true,
    useContainer: false,
    sidebar: {
      defaultExpanded: true,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.TRANSACTION_HISTORY]: {
    title: "Transaction History",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.TRANSACTION_STATUS]: {
    title: "Transaction Status",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.PLAN_SELECTION]: {
    title: "Plan Selection",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.DATABASE_PRODUCT]: {
    title: "Database",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.HELP_CENTRE]: {
    title: "Help Centre",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.JOB_ADD_QUESTIONS]: {
    title: "Add Questions",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [LOGIN]: {
    title: "Login",
    showHeader: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: false
    }
  },
  [LANDING_PAGE]: {
    title: "Landing Page",
    showHeader: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: false
    }
  },
  [Routes.VERIFY_EMAIL]: {
    title: "Verify Email",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    showTeamAddUserModal: true
  },
  [Routes.VERIFY_PAGE]: {
    title: "Verify",
    showHeader: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.TEAMS]: {
    title: "Teams",
    showHeader: true,
    sidebar: {
      defaultExpanded: true,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.TEAMS_LOGS]: {
    title: "Teams Logs",
    showHeader: true,
    parentPath: Routes.TEAMS,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.DOCUMENT_VERIFICATION]: {
    title: "Document Verification",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.JOB_PLAN_SELECTION]: {
    title: "Job Plan Selection",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.CHECKOUT]: {
    title: "Checkout",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.CONTACT_DETAILS]: {
    title: "Basic Profile",
    showHeader: true,
    showBack: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.DOWNLOAD_CANDIDATES_CMP]: {
    title: "Download Candidates",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.DOWNLOAD_CANDIDATES_DATABASE]: {
    title: "Download Candidates",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.BULK_UNLOCK_DATABASE]: {
    title: "Bulk Unlock",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.BULK_UNLOCK_CMP]: {
    title: "Bulk Unlock",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.WA_BROADCAST_CANDIDATE_SELECTION]: {
    title: "Bulk WhatsApp",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.VIEW_BROADCASTS]: {
    title: "Bulk WhatsApp",
    showHeader: true,
    useContainer: false,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.WHATSAPP_BROADCAST]: {
    title: "Bulk WhatsApp",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  [Routes.CREATE_BROADCAST]: {
    title: "Bulk WhatsApp",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    }
  },
  "/widget": {
    title: "Widget",
    showHeader: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    containerStyle: {
      useContainer: false
    }
  },
  [Routes.STANDALONE_DATABASE]: {
    title: "Fynd DB",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  [Routes.SUPERBASE_SEARCH]: {
    title: "Fynd DB",
    showHeader: true,
    sidebar: {
      defaultExpanded: false,
      visible: true,
      useV2Layout: true
    }
  },
  "/select-job-plan": {
    title: "Choose the job type to post",
    showHeader: true,
    containerStyle: {
      useContainer: true
    },
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    backgroundColor: "bg-muted",
    hideCustomerSupport: true
  },
  [Routes.VALIDATE_LINK]: {
    title: "Complete your Payment",
    showHeader: true,
    showBack: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    hideCustomerSupport: true
  },
  [Routes.OFFLINE_TRANSACTION_STATUS]: {
    title: "Transaction Status",
    showHeader: true,
    showBack: false,
    sidebar: {
      defaultExpanded: false,
      visible: false,
      useV2Layout: true
    },
    hideCustomerSupport: true
  }
};

export const getInitialNavState = (pathname, isMobile) => {
  const config = layoutConfig[pathname]?.sidebar || {
    defaultExpanded: false,
    visible: false
  };
  return {
    expanded: isMobile ? false : config.defaultExpanded
  };
};

// Helper functions to get specific configs
export const getSidebarConfig = pathname => {
  const config = layoutConfig[pathname]?.sidebar || {
    defaultExpanded: false,
    visible: false,
    useV2Layout: false
  };

  // If this route has a parent path, use the parent's config
  if (layoutConfig[pathname]?.parentPath) {
    const parentConfig =
      layoutConfig[layoutConfig[pathname].parentPath]?.sidebar || config;
    return {
      ...parentConfig,
      parentPath: layoutConfig[pathname].parentPath
    };
  }

  return config;
};

export const getHeaderConfig = pathname => {
  const appCookie = CookieService.getCookie("is_native_app");
  return {
    title: layoutConfig[pathname]?.title || "",
    showHeader: appCookie ? false : layoutConfig[pathname]?.showHeader ?? true,
    showCredits: layoutConfig[pathname]?.showCredits ?? true,
    showBack: layoutConfig[pathname]?.showBack ?? true,
    sidebar: layoutConfig[pathname]?.sidebar || { visible: false },
    showTeamAddUserModal: layoutConfig[pathname]?.showTeamAddUserModal ?? false,
    hideCustomerSupport: layoutConfig[pathname]?.hideCustomerSupport ?? false,
    visibleWithBackBtn: layoutConfig[pathname]?.visibleWithBackBtn ?? false
  };
};
